import styled from '@emotion/styled/macro';
import { BaseButton, Variables } from '@enter/core';

export const Alert = styled.section`
    display: flex;
    width: 100%;
`;

export const AlertRow = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    background-color: ${Variables.Colors.r10};
    border: 1px solid ${Variables.Colors.r20};
    font-size: 16px;
`;
export const AlertMessage = styled.span`
    font-size: 16px;
    text-align: center;
    flex-grow: 1;
    color: ${Variables.Colors.n85};
`;
export const AlertLinkButton = styled(BaseButton)`
    margin-left: 8px;
    color: ${Variables.Colors.b300};
    border-radius: 6px;
`;
export const AlertButton = styled(BaseButton)`
    flex-grow: 0;
    background-color: ${Variables.Colors.r20};
    border-radius: 6px;
`;
